var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "6px",
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF0D7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-v7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XL-1440---A2",
    transform: "translate(-1172, -28)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1112, 19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF0D7",
    transform: "translate(60.001, 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70523016,1.70625019 L5.73335497,5.70625019 C5.51147978,5.90312481 5.25522988,6 4.99897997,6 C4.74273007,6 4.48710482,5.90234375 4.29179232,5.70703125 L0.31991713,1.70703125 C0.00599234055,1.421875 -0.0796452289,0.990624905 0.0751671071,0.618750095 C0.229979443,0.246875286 0.594916749,0 0.998979496,0 L8.97085469,0 C9.37522976,0 9.74022953,0.243156433 9.89522927,0.6171875 C10.050229,0.991218567 9.99272911,1.421875 9.70522969,1.70625019 L9.70523016,1.70625019 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/Arrow-bottom.d1e7e6515fee64daad16251515d64a60.svg";
export { ForwardRef as ReactComponent };